import { changeActualsType, selectActualsType } from 'legacy/lut/features/partner360/configuration'
import { selectActualsData } from 'legacy/lut/features/partner360/configuration/selectors/selectActualsData'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export const useSyncPartnerActualsType = () => {
  const dispatch = useAppDispatch()
  const actualsType = useSelector(selectActualsType)
  const { valueTypeDefault: defaultType } = useSelector(selectActualsData)
  const { isPartnerUser } = useUserRoles()

  useEffect(() => {
    if (!isPartnerUser) {
      return
    }

    if (!defaultType || defaultType === actualsType) {
      return
    }

    dispatch(changeActualsType(defaultType))
  }, [actualsType, defaultType, dispatch, isPartnerUser])
}
